<template lang="pug">
	modal
		.card
			.card-header
				span.fa.fa-picture.mr-2
				| Vista previa
				button.close(@click="cerrar") &times;
			img(:src="'/src/modulos/eventos/php/api/getImagen.php?imagen=' + evento[tipo]", style="width: 100%;height: auto;")
			.card-footer
				button.btn.btn-sm.btn-danger(@click="eliminar")
					span.fa.fa-trash.mr-2
					| Eliminar imagen
</template>


<script>
export default {
	props: ['tipo', 'evento'],
	methods: {
		eliminar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar imagen',
				mensaje: '¿Quieres eliminar esta imagen?',
				callback: acepta => {
					if (acepta) {
						this.$http.post('eventos/php/api/delImagen.php', {EventoID: this.evento.EventoID, tipo: this.tipo})
							.then(res => {
								this.evento[this.tipo] = null
								this.$emit('cerrar')
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/eventos/vue/components/editor/vistaPrevia.vue